// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { object } from 'prop-types'
import ReactGA from 'react-ga4'
import { withAuthContext } from 'components/Auth'

import {
  Button,
  Jumbotron,
} from 'reactstrap'

const errWrap = {
  border: 'thin solid',
  maxWidth: 500,
}

const stackStyles = {
  maxHeight: '20vh',
  overflow: 'auto',
  whitespace: 'pre',
}

class GlobalErrorBoundary extends React.Component {
  static propTypes = {
    authContext: object.isRequired,
    children: object.isRequired,
  }

  state = {
    hasError: false,
    message: null,
    stack: null,
  }

  componentDidCatch (error, info) {
    const { GA_userId } = this.props.authContext
    const message = error.message || 'Uncaught Error!'
    const stack = info.componentStack

    this.setState({
      hasError: true,
      message,
      stack,
    })

    ReactGA.event({
      action: message,
      category: 'UI uncaught error',
      label: GA_userId,
    })
  }

  render () {
    const {
      hasError,
      message,
      stack,
    } = this.state

    if (hasError) {
      return (
        <div className={'padding-1 display-flex justify-content-center align-items-center margin-1'}>
          <Jumbotron
            className={'border-radius-2 padding-1 margin-1 display-flex flex-direction-column'}
            style={errWrap}>
            <h1>{'Something went wrong.'}</h1>
            <p>{'The application crashed with the following message:'}</p>
            <p className={'error-message padding-top-1 padding-bottom-1'}>
              {message}
            </p>
            <details>
              <summary>{'Component Stack Trace'}</summary>
              <pre style={stackStyles}>{stack}</pre>
            </details>
            <Button
              className={'margin-0-auto'}
              color={'primary'}
              href={'#'}
              onClick={e => { location.reload() }}>
              {'Reload Page'}
            </Button>
          </Jumbotron>
        </div>
      )
    }

    return this.props.children
  }
}

export default withAuthContext(GlobalErrorBoundary)
